var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "arco-brand-preview" },
    [
      _c("section", { staticClass: "hero" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "hero__meta" },
          [
            _c("el-tag", { attrs: { type: "success", effect: "dark" } }, [
              _vm._v("Brand #00A551"),
            ]),
            _c(
              "el-badge",
              { staticClass: "hero__badge", attrs: { value: 12 } },
              [
                _c("el-button", { attrs: { size: "small" } }, [
                  _vm._v("待验收组件"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("el-alert", {
        staticClass: "preview-alert",
        attrs: {
          title:
            "说明：页面自身仅提供轻量布局，主要观察全局主题、边框、阴影、悬停与状态色表现。",
          type: "success",
          closable: false,
          "show-icon": "",
        },
      }),
      _c(
        "section",
        { staticClass: "preview-section" },
        [
          _vm._m(1),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("按钮与链接"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "inline-wrap" },
                        [
                          _c("el-button", { attrs: { type: "primary" } }, [
                            _vm._v("主要按钮"),
                          ]),
                          _c("el-button", { attrs: { type: "success" } }, [
                            _vm._v("成功按钮"),
                          ]),
                          _c("el-button", { attrs: { type: "warning" } }, [
                            _vm._v("警告按钮"),
                          ]),
                          _c("el-button", { attrs: { type: "danger" } }, [
                            _vm._v("危险按钮"),
                          ]),
                          _c(
                            "el-button",
                            { attrs: { type: "primary", plain: "" } },
                            [_vm._v("朴素主按钮")]
                          ),
                          _c(
                            "el-button",
                            { attrs: { type: "warning", plain: "" } },
                            [_vm._v("朴素警告")]
                          ),
                          _c(
                            "el-button",
                            { attrs: { type: "danger", plain: "" } },
                            [_vm._v("朴素危险")]
                          ),
                          _c("el-button", { attrs: { plain: "" } }, [
                            _vm._v("朴素按钮"),
                          ]),
                          _c(
                            "el-button",
                            { attrs: { round: "", icon: "el-icon-check" } },
                            [_vm._v("圆角按钮")]
                          ),
                          _c("el-button", {
                            attrs: {
                              type: "primary",
                              circle: "",
                              icon: "el-icon-search",
                            },
                          }),
                          _c(
                            "el-button",
                            { attrs: { type: "primary", loading: "" } },
                            [_vm._v("加载中")]
                          ),
                          _c("el-button", { attrs: { disabled: "" } }, [
                            _vm._v("禁用按钮"),
                          ]),
                          _c("el-button", { attrs: { type: "text" } }, [
                            _vm._v("文字按钮"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "inline-wrap" },
                        [
                          _c("el-button", { attrs: { size: "mini" } }, [
                            _vm._v("Mini"),
                          ]),
                          _c("el-button", { attrs: { size: "small" } }, [
                            _vm._v("Small"),
                          ]),
                          _c("el-button", [_vm._v("Default")]),
                          _c("el-button", { attrs: { size: "medium" } }, [
                            _vm._v("Medium"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "inline-wrap" },
                        [
                          _c(
                            "el-button-group",
                            [
                              _c(
                                "el-button",
                                { attrs: { icon: "el-icon-arrow-left" } },
                                [_vm._v("上一页")]
                              ),
                              _c("el-button", { attrs: { type: "primary" } }, [
                                _vm._v(" 下一页 "),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-right el-icon--right",
                                }),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "inline-wrap" },
                        [
                          _c(
                            "el-link",
                            { attrs: { type: "primary", underline: false } },
                            [_vm._v("主链接")]
                          ),
                          _c("el-link", { attrs: { type: "success" } }, [
                            _vm._v("成功链接"),
                          ]),
                          _c("el-link", { attrs: { type: "warning" } }, [
                            _vm._v("警告链接"),
                          ]),
                          _c("el-link", { attrs: { type: "danger" } }, [
                            _vm._v("危险链接"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("标签、角标与提示"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "inline-wrap" },
                        [
                          _c("el-tag", [_vm._v("默认标签")]),
                          _c("el-tag", { attrs: { closable: "" } }, [
                            _vm._v("可关闭"),
                          ]),
                          _c("el-tag", { attrs: { effect: "plain" } }, [
                            _vm._v("朴素标签"),
                          ]),
                          _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("成功"),
                          ]),
                          _c("el-tag", { attrs: { type: "info" } }, [
                            _vm._v("信息"),
                          ]),
                          _c("el-tag", { attrs: { type: "warning" } }, [
                            _vm._v("警告"),
                          ]),
                          _c("el-tag", { attrs: { type: "danger" } }, [
                            _vm._v("危险"),
                          ]),
                          _c(
                            "el-tag",
                            { attrs: { type: "danger", effect: "dark" } },
                            [_vm._v("暗色危险")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "inline-wrap" },
                        [
                          _c(
                            "el-badge",
                            { attrs: { value: "new" } },
                            [
                              _c("el-button", { attrs: { size: "small" } }, [
                                _vm._v("消息中心"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-badge",
                            { attrs: { value: 8, type: "primary" } },
                            [
                              _c("el-button", { attrs: { size: "small" } }, [
                                _vm._v("订单"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-badge",
                            { attrs: { "is-dot": "" } },
                            [
                              _c("el-link", { attrs: { type: "primary" } }, [
                                _vm._v("在线状态"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-alert", {
                        attrs: {
                          title:
                            "基础组件区域可重点观察主色、文字层级、边框圆角与悬停态。",
                          type: "info",
                          description:
                            "这条提示用于观察 description、close icon、边框和浅色状态。",
                          "show-icon": "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("空状态"),
                      ]),
                      _c("el-empty", {
                        attrs: {
                          description: "暂无待处理数据",
                          "image-size": 110,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("结果页"),
                      ]),
                      _c(
                        "el-result",
                        {
                          attrs: {
                            icon: "success",
                            title: "品牌换肤校验通过",
                            "sub-title":
                              "继续检查表单、数据和反馈组件的交互状态。",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "extra" },
                            [
                              _c(
                                "el-button",
                                { attrs: { type: "primary", size: "small" } },
                                [_vm._v("继续验收")]
                              ),
                              _c("el-button", { attrs: { size: "small" } }, [
                                _vm._v("查看规范"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "section",
        { staticClass: "preview-section" },
        [
          _vm._m(2),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("头像、图片与分割线"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "inline-wrap media-row" },
                        [
                          _c("el-avatar", {
                            attrs: { size: 44, icon: "el-icon-user-solid" },
                          }),
                          _c(
                            "el-avatar",
                            { attrs: { size: 44, shape: "square" } },
                            [_vm._v("AJ")]
                          ),
                          _c("el-image", {
                            staticClass: "preview-image",
                            attrs: {
                              src: _vm.previewImage,
                              "preview-src-list": _vm.previewImages,
                              fit: "cover",
                            },
                          }),
                          _c("el-image", {
                            staticClass: "preview-image",
                            attrs: { src: _vm.placeholderImage, fit: "cover" },
                          }),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  _vm.imageViewerVisible = true
                                },
                              },
                            },
                            [_vm._v("打开 ImageViewer")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("横向分割线")]
                      ),
                      _c(
                        "div",
                        { staticClass: "divider-demo" },
                        [
                          _c("span", [_vm._v("包裹")]),
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                          _c("span", [_vm._v("路由")]),
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                          _c("span", [_vm._v("轨迹")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("服务式反馈"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "inline-wrap" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.showMessage("success")
                                },
                              },
                            },
                            [_vm._v("成功 Message")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.showMessage("info")
                                },
                              },
                            },
                            [_vm._v("信息 Message")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "warning" },
                              on: {
                                click: function ($event) {
                                  return _vm.showMessage("warning")
                                },
                              },
                            },
                            [_vm._v("警告 Message")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.showMessage("error")
                                },
                              },
                            },
                            [_vm._v("错误 Message")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.showNotification("success")
                                },
                              },
                            },
                            [_vm._v("成功 Notification")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.showNotification("warning")
                                },
                              },
                            },
                            [_vm._v("警告 Notification")]
                          ),
                          _c(
                            "el-button",
                            { on: { click: _vm.showMessageBox } },
                            [_vm._v("MessageBox")]
                          ),
                          _c("el-button", { on: { click: _vm.showLoading } }, [
                            _vm._v("Loading"),
                          ]),
                        ],
                        1
                      ),
                      _c("p", { staticClass: "muted-text" }, [
                        _vm._v(
                          " 这些组件通常挂载到 body，必须单独检查阴影、圆角、按钮主色和遮罩层。 "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "section",
        { staticClass: "preview-section" },
        [
          _vm._m(3),
          _c(
            "el-card",
            { staticClass: "preview-card", attrs: { shadow: "hover" } },
            [
              _c(
                "el-form",
                {
                  ref: "previewForm",
                  staticClass: "preview-form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "110px",
                    "label-position": "right",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "文本输入", required: "" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入品牌名称",
                                  clearable: "",
                                  "prefix-icon": "el-icon-edit",
                                  "suffix-icon": "el-icon-circle-check",
                                },
                                model: {
                                  value: _vm.form.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "name", $$v)
                                  },
                                  expression: "form.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "组合输入" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入订单号",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.form.orderNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "orderNo", $$v)
                                    },
                                    expression: "form.orderNo",
                                  },
                                },
                                [
                                  _c("template", { slot: "prepend" }, [
                                    _vm._v("AJ"),
                                  ]),
                                  _c("template", { slot: "append" }, [
                                    _vm._v("查询"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "禁用输入" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", placeholder: "禁用态" },
                                model: {
                                  value: _vm.form.disabledText,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "disabledText", $$v)
                                  },
                                  expression: "form.disabledText",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-error",
                              attrs: { label: "错误状态" },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "错误状态输入框" },
                                model: {
                                  value: _vm.form.errorText,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "errorText", $$v)
                                  },
                                  expression: "form.errorText",
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "el-form-item__error" },
                                [_vm._v("请填写正确的品牌名称")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-success",
                              attrs: { label: "成功状态" },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "成功状态输入框" },
                                model: {
                                  value: _vm.form.successText,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "successText", $$v)
                                  },
                                  expression: "form.successText",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "多行文本" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  maxlength: "80",
                                  "show-word-limit": "",
                                  rows: 3,
                                  placeholder:
                                    "观察 textarea 背景、字数统计和 focus ring",
                                },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "数字输入" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 0,
                                  max: 999,
                                  "controls-position": "right",
                                },
                                model: {
                                  value: _vm.form.amount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "amount", $$v)
                                  },
                                  expression: "form.amount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "基础下拉" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择状态",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.form.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "status", $$v)
                                    },
                                    expression: "form.status",
                                  },
                                },
                                [
                                  _c(
                                    "el-option-group",
                                    { attrs: { label: "常用状态" } },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "启用",
                                          value: "enabled",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "草稿",
                                          value: "draft",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-option-group",
                                    { attrs: { label: "不可用状态" } },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "停用",
                                          value: "disabled",
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "多选下拉" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    multiple: "",
                                    "collapse-tags": "",
                                    filterable: "",
                                    placeholder: "请选择状态",
                                  },
                                  model: {
                                    value: _vm.form.multiStatus,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "multiStatus", $$v)
                                    },
                                    expression: "form.multiStatus",
                                  },
                                },
                                _vm._l(_vm.statusOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "加载下拉" } },
                            [
                              _c("el-select", {
                                staticStyle: { width: "100%" },
                                attrs: { loading: "", placeholder: "加载中" },
                                model: {
                                  value: _vm.form.loadingStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "loadingStatus", $$v)
                                  },
                                  expression: "form.loadingStatus",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "禁用下拉" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: "",
                                    placeholder: "禁用状态",
                                  },
                                  model: {
                                    value: _vm.form.disabledStatus,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "disabledStatus", $$v)
                                    },
                                    expression: "form.disabledStatus",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "禁用已选",
                                      value: "disabled-selected",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "级联选择" } },
                            [
                              _c("el-cascader", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.regionOptions,
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.region,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "region", $$v)
                                  },
                                  expression: "form.region",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "级联多选" } },
                            [
                              _c("el-cascader", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.regionOptions,
                                  props: { multiple: true },
                                  "collapse-tags": "",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.multiRegion,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "multiRegion", $$v)
                                  },
                                  expression: "form.multiRegion",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "禁用级联" } },
                            [
                              _c("el-cascader", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.regionOptions,
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.form.disabledRegion,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "disabledRegion", $$v)
                                  },
                                  expression: "form.disabledRegion",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "多选框" } },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.form.features,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "features", $$v)
                                    },
                                    expression: "form.features",
                                  },
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "hover" } },
                                    [_vm._v("悬停态")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "focus" } },
                                    [_vm._v("聚焦态")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        label: "disabled",
                                        disabled: "",
                                      },
                                    },
                                    [_vm._v("禁用态")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "半选与禁用" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "inline-wrap inline-wrap--compact",
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { indeterminate: true },
                                      model: {
                                        value: _vm.form.indeterminateChecked,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "indeterminateChecked",
                                            $$v
                                          )
                                        },
                                        expression: "form.indeterminateChecked",
                                      },
                                    },
                                    [_vm._v(" 半选 ")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.disabledChecked,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "disabledChecked",
                                            $$v
                                          )
                                        },
                                        expression: "form.disabledChecked",
                                      },
                                    },
                                    [_vm._v(" 禁用已选 ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "按钮多选" } },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.form.buttonFeatures,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "buttonFeatures", $$v)
                                    },
                                    expression: "form.buttonFeatures",
                                  },
                                },
                                [
                                  _c(
                                    "el-checkbox-button",
                                    { attrs: { label: "table" } },
                                    [_vm._v("表格")]
                                  ),
                                  _c(
                                    "el-checkbox-button",
                                    { attrs: { label: "form" } },
                                    [_vm._v("表单")]
                                  ),
                                  _c(
                                    "el-checkbox-button",
                                    { attrs: { label: "overlay" } },
                                    [_vm._v("浮层")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单选框" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.scene,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "scene", $$v)
                                    },
                                    expression: "form.scene",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "light" } },
                                    [_vm._v("浅色页")]
                                  ),
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "dashboard" } },
                                    [_vm._v("仪表盘")]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        label: "disabled",
                                        disabled: "",
                                      },
                                    },
                                    [_vm._v("禁用项")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "按钮单选" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.mode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "mode", $$v)
                                    },
                                    expression: "form.mode",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "formal" } },
                                    [_vm._v("正式")]
                                  ),
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "test" } },
                                    [_vm._v("测试")]
                                  ),
                                  _c(
                                    "el-radio-button",
                                    {
                                      attrs: {
                                        label: "disabled",
                                        disabled: "",
                                      },
                                    },
                                    [_vm._v("禁用")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开关" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-text": "已启用",
                                  "inactive-text": "已停用",
                                },
                                model: {
                                  value: _vm.form.enabled,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "enabled", $$v)
                                  },
                                  expression: "form.enabled",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "禁用开关" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  disabled: "",
                                  "active-text": "禁用已启用",
                                },
                                model: {
                                  value: _vm.form.disabledSwitch,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "disabledSwitch", $$v)
                                  },
                                  expression: "form.disabledSwitch",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "关闭/禁用开关" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "inline-wrap inline-wrap--compact",
                                },
                                [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-text": "开",
                                      "inactive-text": "关",
                                    },
                                    model: {
                                      value: _vm.form.enabledOff,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "enabledOff", $$v)
                                      },
                                      expression: "form.enabledOff",
                                    },
                                  }),
                                  _c("el-switch", {
                                    attrs: {
                                      disabled: "",
                                      "inactive-text": "禁用关闭",
                                    },
                                    model: {
                                      value: _vm.form.disabledSwitchOff,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "disabledSwitchOff",
                                          $$v
                                        )
                                      },
                                      expression: "form.disabledSwitchOff",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "日期选择" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  "picker-options": _vm.datePickerOptions,
                                },
                                model: {
                                  value: _vm.form.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "date", $$v)
                                  },
                                  expression: "form.date",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "日期范围" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "picker-options": _vm.dateRangePickerOptions,
                                },
                                model: {
                                  value: _vm.form.dateRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "dateRange", $$v)
                                  },
                                  expression: "form.dateRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "多日期" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "dates",
                                  placeholder: "选择多个日期",
                                },
                                model: {
                                  value: _vm.form.dates,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "dates", $$v)
                                  },
                                  expression: "form.dates",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "月份范围" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "monthrange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始月份",
                                  "end-placeholder": "结束月份",
                                },
                                model: {
                                  value: _vm.form.monthRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "monthRange", $$v)
                                  },
                                  expression: "form.monthRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "禁用日期" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  disabled: "",
                                  placeholder: "禁用日期",
                                },
                                model: {
                                  value: _vm.form.disabledDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "disabledDate", $$v)
                                  },
                                  expression: "form.disabledDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "时间选择" } },
                            [
                              _c("el-time-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "选择时间" },
                                model: {
                                  value: _vm.form.time,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "time", $$v)
                                  },
                                  expression: "form.time",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "时间范围" } },
                            [
                              _c("el-time-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "is-range": "",
                                  "range-separator": "至",
                                  "start-placeholder": "开始时间",
                                  "end-placeholder": "结束时间",
                                },
                                model: {
                                  value: _vm.form.timeRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "timeRange", $$v)
                                  },
                                  expression: "form.timeRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "禁用时间" } },
                            [
                              _c("el-time-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: "",
                                  placeholder: "禁用时间",
                                },
                                model: {
                                  value: _vm.form.disabledTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "disabledTime", $$v)
                                  },
                                  expression: "form.disabledTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "el-select-v2" } },
                            [
                              _c("el-select-v2", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.selectV2Options,
                                  filterable: "",
                                  clearable: "",
                                  placeholder: "请选择站点",
                                },
                                model: {
                                  value: _vm.form.selectV2,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "selectV2", $$v)
                                  },
                                  expression: "form.selectV2",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "el-select-v2 多选" } },
                            [
                              _c("el-select-v2", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.selectV2Options,
                                  multiple: "",
                                  "collapse-tags": "",
                                  filterable: "",
                                  placeholder: "请选择多个站点",
                                },
                                model: {
                                  value: _vm.form.selectV2Multiple,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "selectV2Multiple", $$v)
                                  },
                                  expression: "form.selectV2Multiple",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "el-select-v2 禁用" } },
                            [
                              _c("el-select-v2", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.selectV2Options,
                                  disabled: "",
                                  placeholder: "禁用站点",
                                },
                                model: {
                                  value: _vm.form.disabledSelectV2,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "disabledSelectV2", $$v)
                                  },
                                  expression: "form.disabledSelectV2",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, xl: 16 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "上传" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    action: "#",
                                    "auto-upload": false,
                                    "file-list": _vm.uploadFiles,
                                    "list-type": "text",
                                    "on-change": _vm.handleUploadChange,
                                    "on-remove": _vm.handleUploadRemove,
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                    },
                                    [_vm._v("选择文件")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-upload__tip",
                                      attrs: { slot: "tip" },
                                      slot: "tip",
                                    },
                                    [
                                      _vm._v(
                                        " 仅演示上传列表、按钮、提示文案和边框样式，不会发起真实请求。 "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, xl: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "拖拽上传" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    action: "#",
                                    drag: "",
                                    "auto-upload": false,
                                    "file-list": [],
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-upload" }),
                                  _c(
                                    "div",
                                    { staticClass: "el-upload__text" },
                                    [
                                      _vm._v("拖拽文件到这里，或"),
                                      _c("em", [_vm._v("点击上传")]),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "section",
        { staticClass: "preview-section" },
        [
          _vm._m(4),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, xl: 16 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("表格与分页"),
                      ]),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.tableData,
                            border: "",
                            stripe: "",
                            "show-summary": "",
                            "highlight-current-row": "",
                            "current-row-key": "el-form",
                            "row-key": "name",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "selection",
                              width: "48",
                              fixed: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { type: "expand", width: "48" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", { staticClass: "table-expand" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(row.name) +
                                          " 对标 " +
                                          _vm._s(row.arcoPath) +
                                          "，重点观察展开区域背景与固定列阴影。 "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "组件",
                              "min-width": "140",
                              fixed: "",
                              sortable: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "category",
                              label: "分类",
                              "min-width": "120",
                              filters: _vm.categoryFilters,
                              "filter-method": _vm.filterCategory,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "count",
                              label: "状态数",
                              "min-width": "100",
                              sortable: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "status",
                              label: "状态",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: row.statusType,
                                          size: "small",
                                        },
                                      },
                                      [_vm._v(_vm._s(row.status))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "desc",
                              label: "说明",
                              "min-width": "220",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "140",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-button",
                                      { attrs: { type: "text" } },
                                      [_vm._v("查看")]
                                    ),
                                    _c(
                                      "el-button",
                                      { attrs: { type: "text" } },
                                      [_vm._v("记录 " + _vm._s(row.count))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "pagination-wrap" },
                        [
                          _c("el-pagination", {
                            attrs: {
                              background: "",
                              layout: "total, sizes, prev, pager, next, jumper",
                              "current-page": 1,
                              "page-size": 5,
                              "page-sizes": [5, 10, 20],
                              total: 15,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pagination-wrap pagination-wrap--compact",
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              small: "",
                              layout: "prev, pager, next",
                              "current-page": 1,
                              "page-size": 5,
                              total: 15,
                            },
                          }),
                          _c("el-pagination", {
                            attrs: {
                              disabled: "",
                              layout: "prev, pager, next",
                              "current-page": 1,
                              "page-size": 5,
                              total: 15,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, xl: 8 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("描述列表"),
                      ]),
                      _c(
                        "el-descriptions",
                        { attrs: { column: 1, border: "" } },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "页面用途" } },
                            [_vm._v("视觉验收")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "数据来源" } },
                            [_vm._v("本地静态数据")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "路由策略" } },
                            [_vm._v("constantRoutes hidden")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "品牌主色" } },
                            [_vm._v("#00A551")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 8 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("树形结构"),
                      ]),
                      _c("el-tree", {
                        attrs: {
                          data: _vm.treeData,
                          "node-key": "id",
                          "default-expand-all": "",
                          "show-checkbox": "",
                          "highlight-current": "",
                          draggable: "",
                          "current-node-key": "12",
                          "default-checked-keys": [13],
                          "expand-on-click-node": false,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 8 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("进度条"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "stack-wrap" },
                        [
                          _c("el-progress", { attrs: { percentage: 28 } }),
                          _c("el-progress", {
                            attrs: { percentage: 62, status: "success" },
                          }),
                          _c("el-progress", {
                            attrs: { percentage: 76, status: "warning" },
                          }),
                          _c("el-progress", {
                            attrs: { percentage: 90, status: "exception" },
                          }),
                          _c("el-progress", {
                            attrs: { type: "circle", percentage: 68 },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 8 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("时间线"),
                      ]),
                      _c(
                        "el-timeline",
                        _vm._l(_vm.timelineData, function (item) {
                          return _c(
                            "el-timeline-item",
                            {
                              key: item.title,
                              attrs: { timestamp: item.time, type: item.type },
                            },
                            [_vm._v(" " + _vm._s(item.title) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "section",
        { staticClass: "preview-section" },
        [
          _vm._m(5),
          _c(
            "el-card",
            { staticClass: "preview-card", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                { staticClass: "inline-wrap" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = true
                        },
                      },
                    },
                    [_vm._v("打开 Dialog")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.drawerVisible = true
                        },
                      },
                    },
                    [_vm._v("打开 Drawer")]
                  ),
                  _c(
                    "el-dropdown",
                    { attrs: { "split-button": "", type: "primary" } },
                    [
                      _vm._v(" 操作菜单 "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c("el-dropdown-item", [_vm._v("查看详情")]),
                          _c("el-dropdown-item", [_vm._v("复制链接")]),
                          _c("el-dropdown-item", { attrs: { divided: "" } }, [
                            _vm._v("归档"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "top",
                        width: "220",
                        trigger: "hover",
                        content: "这里可以观察气泡背景、阴影、箭头和文本样式。",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { slot: "reference" }, slot: "reference" },
                        [_vm._v("悬停 Popover")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-popconfirm",
                    {
                      attrs: {
                        title: "确认仅作演示，不执行真实删除吗？",
                        "confirm-button-text": "确认",
                        "cancel-button-text": "取消",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "reference",
                            type: "danger",
                            plain: "",
                          },
                          slot: "reference",
                        },
                        [_vm._v("Popconfirm")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tooltip",
                    {
                      attrs: { content: "Tooltip 文案示例", placement: "top" },
                    },
                    [_c("el-button", [_vm._v("Tooltip")])],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "section",
        { staticClass: "preview-section" },
        [
          _vm._m(6),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, xl: 14 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("页签与面包屑"),
                      ]),
                      _c(
                        "el-breadcrumb",
                        { attrs: { separator: "/" } },
                        [
                          _c("el-breadcrumb-item", [_vm._v("UI Preview")]),
                          _c("el-breadcrumb-item", [_vm._v("Arco Brand")]),
                          _c("el-breadcrumb-item", [_vm._v("Visual Check")]),
                        ],
                        1
                      ),
                      _c(
                        "el-tabs",
                        {
                          staticClass: "preview-tabs",
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "组件状态", name: "state" } },
                            [
                              _c("p", [
                                _vm._v(
                                  "观察选中态、标签间距、下划线或卡片式样式。"
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "交互反馈", name: "feedback" } },
                            [
                              _c("p", [
                                _vm._v(
                                  "观察 hover、active、disabled 等状态色是否统一。"
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "布局间距", name: "layout" } },
                            [
                              _c("p", [
                                _vm._v(
                                  "观察卡片、区块、标题、内边距是否符合品牌基调。"
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "禁用项",
                                name: "disabled",
                                disabled: "",
                              },
                            },
                            [_c("p", [_vm._v("禁用项仅用于观察颜色。")])]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-tabs",
                        {
                          staticClass: "preview-tabs",
                          attrs: { type: "card" },
                          model: {
                            value: _vm.activeCardTab,
                            callback: function ($$v) {
                              _vm.activeCardTab = $$v
                            },
                            expression: "activeCardTab",
                          },
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "卡片 Tab", name: "card-a" } },
                            [_vm._v("卡片式页签。")]
                          ),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "禁用 Card",
                                name: "card-b",
                                disabled: "",
                              },
                            },
                            [_vm._v("禁用卡片。")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-tabs",
                        {
                          staticClass: "preview-tabs",
                          attrs: { type: "border-card" },
                          model: {
                            value: _vm.activeBorderTab,
                            callback: function ($$v) {
                              _vm.activeBorderTab = $$v
                            },
                            expression: "activeBorderTab",
                          },
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "Border A", name: "border-a" } },
                            [_vm._v("带边框页签。")]
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "Border B", name: "border-b" } },
                            [_vm._v("观察 header 背景。")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, xl: 10 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("步骤条"),
                      ]),
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: 2,
                            "finish-status": "success",
                            "align-center": "",
                          },
                        },
                        [
                          _c("el-step", { attrs: { title: "加载样式" } }),
                          _c("el-step", { attrs: { title: "逐项验收" } }),
                          _c("el-step", { attrs: { title: "记录问题" } }),
                        ],
                        1
                      ),
                      _c(
                        "el-steps",
                        {
                          staticClass: "preview-steps-simple",
                          attrs: { active: 1, simple: "" },
                        },
                        [
                          _c("el-step", { attrs: { title: "简单步骤" } }),
                          _c("el-step", { attrs: { title: "进行中" } }),
                          _c("el-step", { attrs: { title: "等待" } }),
                        ],
                        1
                      ),
                      _c(
                        "el-steps",
                        {
                          staticClass: "preview-steps-vertical",
                          attrs: { active: 1, direction: "vertical" },
                        },
                        [
                          _c("el-step", {
                            attrs: { title: "垂直成功", status: "success" },
                          }),
                          _c("el-step", {
                            attrs: { title: "垂直错误", status: "error" },
                          }),
                          _c("el-step", { attrs: { title: "垂直等待" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("折叠面板"),
                      ]),
                      _c(
                        "el-collapse",
                        {
                          model: {
                            value: _vm.activeCollapse,
                            callback: function ($$v) {
                              _vm.activeCollapse = $$v
                            },
                            expression: "activeCollapse",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              attrs: { name: "basic", title: "基础组件观察点" },
                            },
                            [
                              _vm._v(
                                " 注意按钮主色、普通态背景、文字对比度与 tag 边框。 "
                              ),
                            ]
                          ),
                          _c(
                            "el-collapse-item",
                            {
                              attrs: { name: "form", title: "表单组件观察点" },
                            },
                            [
                              _vm._v(
                                " 注意 input 聚焦边框、select 下拉面板、checkbox/radio 选中态。 "
                              ),
                            ]
                          ),
                          _c(
                            "el-collapse-item",
                            {
                              attrs: { name: "data", title: "数据组件观察点" },
                            },
                            [
                              _vm._v(
                                " 注意表头、分隔线、分页、timeline 节点颜色。 "
                              ),
                            ]
                          ),
                          _c(
                            "el-collapse-item",
                            {
                              attrs: {
                                name: "disabled",
                                title: "禁用折叠项",
                                disabled: "",
                              },
                            },
                            [_vm._v(" 仅用于观察禁用态。 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("轮播图"),
                      ]),
                      _c(
                        "el-carousel",
                        {
                          attrs: {
                            height: "180px",
                            "indicator-position": "outside",
                          },
                        },
                        _vm._l(_vm.carouselItems, function (item) {
                          return _c("el-carousel-item", { key: item.title }, [
                            _c("div", { staticClass: "carousel-slide" }, [
                              _c("strong", [_vm._v(_vm._s(item.title))]),
                              _c("span", [_vm._v(_vm._s(item.desc))]),
                            ]),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "preview-card", attrs: { shadow: "hover" } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("滚动条"),
              ]),
              _c("el-scrollbar", { staticStyle: { height: "180px" } }, [
                _c(
                  "div",
                  { staticClass: "scroll-demo" },
                  _vm._l(_vm.scrollbarItems, function (item) {
                    return _c(
                      "div",
                      { key: item, staticClass: "scroll-item" },
                      [_vm._v(" " + _vm._s(item) + " ")]
                    )
                  }),
                  0
                ),
              ]),
              _c("el-scrollbar", { staticClass: "horizontal-scrollbar" }, [
                _c(
                  "div",
                  { staticClass: "horizontal-scrollbar__content" },
                  _vm._l(_vm.horizontalItems, function (item) {
                    return _c("span", { key: item }, [_vm._v(_vm._s(item))])
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, xl: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("菜单状态"),
                      ]),
                      _c(
                        "el-menu",
                        {
                          staticClass: "preview-menu",
                          attrs: {
                            "default-active": _vm.previewMenuActive,
                            mode: "vertical",
                          },
                          on: {
                            select: function ($event) {
                              _vm.previewMenuActive = $event
                            },
                          },
                        },
                        [
                          _c(
                            "el-menu-item",
                            { attrs: { index: "dashboard" } },
                            [
                              _c("i", { staticClass: "el-icon-data-line" }),
                              _c(
                                "span",
                                { attrs: { slot: "title" }, slot: "title" },
                                [_vm._v("数据看板")]
                              ),
                            ]
                          ),
                          _c(
                            "el-submenu",
                            { attrs: { index: "order" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c("i", { staticClass: "el-icon-truck" }),
                                _c("span", [_vm._v("订单中心")]),
                              ]),
                              _c(
                                "el-menu-item",
                                { attrs: { index: "order-list" } },
                                [_vm._v("订单列表")]
                              ),
                              _c(
                                "el-menu-item",
                                { attrs: { index: "order-track" } },
                                [_vm._v("轨迹查询")]
                              ),
                              _c(
                                "el-submenu",
                                { attrs: { index: "order-more" } },
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v("更多操作"),
                                  ]),
                                  _c(
                                    "el-menu-item",
                                    { attrs: { index: "order-more-import" } },
                                    [_vm._v("批量导入")]
                                  ),
                                  _c(
                                    "el-menu-item",
                                    { attrs: { index: "order-more-export" } },
                                    [_vm._v("批量导出")]
                                  ),
                                ],
                                2
                              ),
                            ],
                            2
                          ),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "settings", disabled: "" } },
                            [
                              _c("i", { staticClass: "el-icon-setting" }),
                              _c(
                                "span",
                                { attrs: { slot: "title" }, slot: "title" },
                                [_vm._v("禁用菜单")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, xl: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "preview-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("容器布局"),
                      ]),
                      _c(
                        "el-container",
                        { staticClass: "container-demo" },
                        [
                          _c("el-aside", { attrs: { width: "140px" } }, [
                            _vm._v("Aside"),
                          ]),
                          _c(
                            "el-container",
                            [
                              _c("el-main", [
                                _c("i", {
                                  staticClass:
                                    "el-icon-box container-demo__icon",
                                }),
                                _vm._v(" Main 内容区 "),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "section",
        { staticClass: "preview-section" },
        [
          _vm._m(7),
          _c(
            "el-card",
            {
              staticClass: "preview-card shell-card",
              attrs: { shadow: "hover" },
            },
            [
              _c("div", { staticClass: "shell-demo" }, [
                _c(
                  "aside",
                  { staticClass: "shell-sidebar" },
                  [
                    _c("div", { staticClass: "shell-logo" }, [
                      _c("span", { staticClass: "shell-logo__mark" }, [
                        _vm._v("AJ"),
                      ]),
                      _c("span", [_vm._v("安骏快递")]),
                    ]),
                    _vm._l(_vm.shellMenu, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.label,
                          class: [
                            "shell-menu-item",
                            { "is-active": item.active },
                          ],
                        },
                        [
                          _c("i", { class: item.icon }),
                          _c("span", [_vm._v(_vm._s(item.label))]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _c("main", { staticClass: "shell-main" }, [
                  _c("header", { staticClass: "shell-navbar" }, [
                    _c("div", { staticClass: "shell-breadcrumb" }, [
                      _c("i", { staticClass: "el-icon-s-fold" }),
                      _c("span", [_vm._v("首页 / UI Preview / Arco Brand")]),
                    ]),
                    _c("div", { staticClass: "shell-actions" }, [
                      _c("span", [_c("i", { staticClass: "el-icon-bell" })]),
                      _c("span", [_c("i", { staticClass: "el-icon-search" })]),
                      _c(
                        "div",
                        { staticClass: "shell-user" },
                        [
                          _c("el-avatar", { attrs: { size: 30 } }, [
                            _vm._v("AJ"),
                          ]),
                          _c("div", [
                            _c("strong", [_vm._v("运营中心")]),
                            _c("em", [_vm._v("Admin User")]),
                          ]),
                          _c("i", { staticClass: "el-icon-arrow-down" }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "shell-tags" }, [
                    _c("span", { staticClass: "shell-tag is-active" }, [
                      _vm._v("工作台"),
                    ]),
                    _c("span", { staticClass: "shell-tag" }, [
                      _vm._v("订单管理 "),
                      _c("i", { staticClass: "el-icon-close" }),
                    ]),
                    _c("span", { staticClass: "shell-tag" }, [
                      _vm._v("轨迹查询 "),
                      _c("i", { staticClass: "el-icon-close" }),
                    ]),
                  ]),
                  _c("div", { staticClass: "shell-content" }, [
                    _c("div", { staticClass: "shell-stat" }, [
                      _c("span", [_vm._v("今日订单")]),
                      _c("strong", [_vm._v("12,840")]),
                    ]),
                    _c("div", { staticClass: "shell-stat" }, [
                      _c("span", [_vm._v("妥投率")]),
                      _c("strong", [_vm._v("98.6%")]),
                    ]),
                    _c("div", { staticClass: "shell-stat" }, [
                      _c("span", [_vm._v("异常件")]),
                      _c("strong", [_vm._v("32")]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "section",
        { staticClass: "preview-section" },
        [
          _vm._m(8),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, md: 8 } },
                [
                  _c(
                    "el-card",
                    {
                      staticClass: "preview-card placeholder-card",
                      attrs: { shadow: "hover" },
                    },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("virtual-list 占位"),
                      ]),
                      _c("p", [
                        _vm._v("仓库内存在 `vue-virtual-scroll-list` 依赖。"),
                      ]),
                      _c("p", [
                        _vm._v(
                          "本验收页不强依赖其运行，仅保留卡片用于观察容器、标题和说明文字样式。"
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, md: 8 } },
                [
                  _c(
                    "el-card",
                    {
                      staticClass: "preview-card placeholder-card",
                      attrs: { shadow: "hover" },
                    },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("apexchart 占位"),
                      ]),
                      _c("p", [_vm._v("项目已全局注册 `vue-apexcharts`。")]),
                      _c("p", [
                        _vm._v(
                          "为避免引入额外图表配置噪音，这里仅保留占位说明，不做真实图表渲染。"
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, md: 8 } },
                [
                  _c(
                    "el-card",
                    {
                      staticClass: "preview-card placeholder-card",
                      attrs: { shadow: "hover" },
                    },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v("vue-esign 占位"),
                      ]),
                      _c("p", [
                        _vm._v(
                          "签名板用于观察边框和操作区时通常需要更多交互。"
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "本页仅保留静态占位，避免误触和无意义的画布依赖。"
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Dialog 示例",
            visible: _vm.dialogVisible,
            width: "460px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("p", [
            _vm._v("这里可以检查弹窗的圆角、阴影、头部、正文排版和按钮主色。"),
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "Drawer 示例",
            visible: _vm.drawerVisible,
            "with-header": true,
            size: "32%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "drawer-content" },
            [
              _c("p", [
                _vm._v("抽屉适合观察遮罩、边缘阴影、标题样式和内部滚动区域。"),
              ]),
              _c(
                "el-descriptions",
                { attrs: { column: 1, border: "" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "类型" } }, [
                    _vm._v("视觉验收辅助"),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "交互" } }, [
                    _vm._v("仅本地状态"),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "风险" } }, [
                    _vm._v("无接口依赖"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm.imageViewerVisible
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": function () {
                _vm.imageViewerVisible = false
              },
              "url-list": _vm.previewImages,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", { staticClass: "hero__eyebrow" }, [
        _vm._v("/ui-preview/arco-brand"),
      ]),
      _c("h1", [_vm._v("Arco Brand UI 示例验收页")]),
      _c("p", { staticClass: "hero__desc" }, [
        _vm._v(
          " 该页面只用于浏览器视觉验收，所有数据均为本地写死，用来检查 Element UI 组件是否已被全局品牌样式覆盖。 "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("基础组件")]),
      _c("span", [
        _vm._v("Button / Link / Tag / Badge / Alert / Card / Empty / Result"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("媒体与服务式反馈")]),
      _c("span", [
        _vm._v(
          "Avatar / Image / ImageViewer / Divider / Message / MessageBox / Notification / Loading"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("表单组件")]),
      _c("span", [
        _vm._v(
          "Form / Input / Select / Cascader / Checkbox / Radio / Switch / Picker / Upload"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("数据展示")]),
      _c("span", [
        _vm._v(
          "Table / Pagination / Descriptions / Tree / Progress / Timeline"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("反馈组件")]),
      _c("span", [
        _vm._v("Dialog / Drawer / Dropdown / Popover / Popconfirm / Tooltip"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("导航组件")]),
      _c("span", [
        _vm._v("Tabs / Breadcrumb / Collapse / Steps / Carousel / Scrollbar"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("后台壳层")]),
      _c("span", [
        _vm._v("Sidebar / Navbar / TagsView / AppMain static shell"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("特殊边界")]),
      _c("span", [
        _vm._v(
          "el-select-v2 已实装；virtual-list / apexchart / vue-esign 使用占位卡片"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }